import icons from './icons';

const directives = {
  icon: {
    bind(el, { arg }) {
      if ( icons === undefined ) {
        console.error('Icons not loaded');
        return;
      }

      const icon = icons[arg] || icons[el.dataset.icon];

      if ( icon === undefined ) {
        console.warn(`Icon '${arg}' does not exist`);
        return;
      }

      el.innerHTML = `<svg viewBox="${icon.viewBox}">${icon.content}</svg>`;
    }
  }
};
export default directives;
